export const getMembershipFeatures = '/api/v1/memberships/features';
export const getMembershipType = type => `/api/v1/memberships?package=${type}`;
export const getPlans = '/api/v1/memberships';